import React from 'react'
import { MainContentPanel } from 'features/bpDetails/BpDetails'
import GuruChat from './guru/GuruChat'

const BPGuru = () => {
  return (
    <MainContentPanel>
      <GuruChat />
    </MainContentPanel>
  )
}

export default BPGuru
